import SessionService from '@/modules/core/session/services/SessionService';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { dispatches } from '@/modules/core/app/helpers/store';
import { WelcomePathName } from '@/modules/core/app/constants/router.constants';

const LoginPage = () =>
  import(/* webpackChunkName: "login-page" */ '@/modules/core/session/pages/LoginPage');
const WelcomePage = () =>
  import(/* webpackChunkName: "welcome-page" */ '@/modules/core/app/pages/WelcomePage');
const HomePage = () =>
  import(/* webpackChunkName: "home-page" */ '@/modules/core/app/pages/HomePage');
const MaiaChatBot = () =>
  import(/* webpackChunkName: "maia-chat-bot" */ '@/modules/ta/chatbot/maia-chat-bot.vue');
const AIChatBot = () =>
  import(/* webpackChunkName: "ai-chat-bot" */ '@/modules/ta/chatbot/ai-chat-bot.vue');
const MMM = () => import(/* webpackChunkName: "maia-chat-bot" */ '@/modules/ta/chatbot/m-m-m.vue');
const InsightsEngine = () =>
  import(/* webpackChunkName: "ai-chat-bot" */ '@/modules/ta/chatbot/insights-engine.vue');
const OnboardingPage = () =>
  import(
    /* webpackChunkName: "on-boarding-page" */ '@/modules/core/onboarding/pages/OnboardingPage'
  );
const GoogleLoginPage = () =>
  import(
    /* webpackChunkName: "google-login-page" */ '@/modules/core/session/pages/GoogleLoginPage'
  );
const ResetPasswordPage = () =>
  import(
    /* webpackChunkName: "reset-password-page" */ '@/modules/core/session/pages/ResetPasswordPage'
  );

export const loginRoute = {
  path: '/login',
  name: 'login',
  component: LoginPage,
};

export const onboardingRoute = {
  path: '/onboarding',
  name: 'onboarding',
  component: OnboardingPage,
};

export const welcomeRoute = {
  path: '/welcome',
  name: WelcomePathName,
  component: WelcomePage,
};

export const HomeRoute = {
  path: '/home',
  name: 'home',
  component: HomePage,
};

export const MaiaChatBotRoute = {
  path: '/maiachatbot',
  name: 'maiachatbot',
  component: MaiaChatBot,
};

export const AIChatBotRoute = {
  path: '/aichatbot',
  name: 'aichatbot',
  component: AIChatBot,
};

export const MMMRoute = {
  path: '/mmm',
  name: 'mmm',
  component: MMM,
};

export const InsightsEngineRoute = {
  path: '/insightsengine',
  name: 'insightsengine',
  component: InsightsEngine,
};

export const googleLogin = {
  path: '/google_login/c/:code/s/:from_google_login_redirect_state/p/:from_google_login_redirect_params',
  name: 'googlelogin',
  component: GoogleLoginPage,
};

export const resetPasswordRoute = {
  path: '/resetpassword/:request_id/:verification_code/:user_id',
  name: 'resetpassword',
  component: ResetPasswordPage,
};

export const remoteLoginRoute = {
  path: '/remote_login',
  name: 'remotelogin',
  async beforeEnter(to, from, next) {
    try {
      // Preload user settings and initialize segment
      await dispatches.session.updateUserSettings();
    } catch (e) {
      Logger.log(e.message);
    }
    next(SessionService.getLoginRedirectPath());
  },
};

// Once we migrate all the products billing to new ui, we will be removing "zest" from below routes.
export const supBillingRouter = PageRouteConfig.factory(
  [
    {
      path: '/billing/manageplans',
      name: 'billingmanageplans',
      component: () =>
        import(
          /* webpackChunkName: "manage-plans-page" */ '@/modules/core/billing/pages/ManagePlansPage.vue'
        ),
    },
    {
      path: '/billing/overview',
      name: 'billingoverview',
      component: () =>
        import(
          /* webpackChunkName: "billing-info-page" */ '@/modules/core/billing/pages/BillingInfoPage.vue'
        ),
    },
    {
      path: '/billing/invoices',
      name: 'billinginvoices',
      component: () =>
        import(
          /* webpackChunkName: "billing-info-page-invoices" */ '@/modules/core/billing/pages/BillingInfoPage.vue'
        ),
    },
    {
      path: '/billing/billingdetails',
      name: 'billingdetails',
      component: () =>
        import(
          /* webpackChunkName: "billing-info-page-billing-details" */ '@/modules/core/billing/pages/BillingInfoPage.vue'
        ),
    },
    {
      path: '/billing/customize',
      name: 'customizeplan',
      component: () =>
        import(
          /* webpackChunkName: "customize-plan" */ '@/modules/core/billing/pages/CustomizePlanPage.vue'
        ),
    },
  ],
  Module.BILLING
);
